import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { deleteUser } from "../thunks/deleteUser";
import { setFetchState } from "../usersDataReducer";

export const useRoleDelete = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.users.fetchState
	);

	const dispatch = useDispatch();
	const dispatchDeleteUser = React.useCallback(
		(id: string) => dispatch(deleteUser(id)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchState({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchDeleteUser] as [typeof fetchState, typeof dispatchDeleteUser]
};
